import styled from "styled-components";

export const ResultContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
